import { ASYNC_TYPES } from '@travel-frontend/state-handling-sdk';
import axios from '../../../utils/axiosInstance.js';
export const SERVICE_CONFIG = 'serviceConfig/SERVICE_CONFIG';
export function getServiceConfig(url) {
  return {
    types: ASYNC_TYPES(SERVICE_CONFIG),
    callAPI: () => axios.get(url).then(res => res.data)
  };
}